import { useAppStore, AppStateModel } from "./store";

export const useAppState = (): AppStateModel => useAppStore();
